// Boxsito theme: soft header, scroll-driven unboxing hero, box builder on the store's real products, gift card, order to cart.
// Each part only runs when its section is on the page, so every section can be added, removed or reordered in the editor.
(() => {
const $ = s => document.querySelector(s);
const $$ = s => [...document.querySelectorAll(s)];
const lang = document.documentElement.lang.toLowerCase().startsWith("ar") ? "ar" : "en";
const L = (a, e) => (lang === "en" ? e : a);
const num = n => n.toLocaleString(lang === "en" ? "en-US" : "ar-EG");
const egp = n => L(`${num(n)} ج`, `EGP ${num(n)}`);
const isAr = s => /[؀-ۿ]/.test(s);
const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
const easeOut = t => 1 - Math.pow(1 - t, 4);
const easeInOut = t => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
const mobile = matchMedia("(max-width:980px)");
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const icon = (k, cls = "ic") => `<svg class="${cls}" aria-hidden="true"><use href="#i-${k}"/></svg>`;
const json = id => { const el = document.getElementById(id); return el ? JSON.parse(el.textContent) : null; };
const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

// black shredded paper inside the boxes (hero + builder)
(function shreds() {
  let seed = 7; const rnd = () => (seed = (seed * 16807) % 2147483647) / 2147483647;
  const cols = ["#050404", "#151212", "#221d1d", "#2f2828", "#3e3535"];
  let out = "";
  for (let i = 0; i < 170; i++) {
    let x = rnd() * 220 - 10, y = rnd() * 180 - 10, a = rnd() * Math.PI * 2, d = `M${x.toFixed(1)} ${y.toFixed(1)}`;
    for (let k = 0; k < 3; k++) {
      a += (rnd() - .5) * 2.4; const l = 6 + rnd() * 9;
      const cx = x + Math.cos(a + 1) * l, cy = y + Math.sin(a + 1) * l; x += Math.cos(a) * l; y += Math.sin(a) * l;
      d += ` Q${cx.toFixed(1)} ${cy.toFixed(1)} ${x.toFixed(1)} ${y.toFixed(1)}`;
    }
    out += `<path d="${d}" fill="none" stroke="${cols[i % cols.length]}" stroke-width="${(1.1 + rnd() * 1.5).toFixed(2)}" stroke-linecap="round"/>`;
  }
  $$(".shreds").forEach(s => s.innerHTML = out);
})();

/* ---------- header: solid after the top, hides on scroll down, returns on scroll up; the menu ---------- */
const header = $("#top");
if (header) {
  let lastY = scrollY;
  const onHeader = () => {
    const y = scrollY;
    header.classList.toggle("solid", y > 20);
    if (y > 160 && y > lastY + 6 && !header.classList.contains("search-open")) header.classList.add("hide");
    else if (y < lastY - 6 || y < 160) header.classList.remove("hide");
    lastY = y;
  };
  addEventListener("scroll", onHeader, { passive: true });
  onHeader();
  const menuBtn = $("#menuBtn"), menu = $("#menu");
  const setMenu = open => { menu.hidden = !open; menuBtn.setAttribute("aria-expanded", open); header.classList.toggle("menu-open", open); };
  menuBtn.addEventListener("click", e => { e.stopPropagation(); setMenu(menu.hidden); });
  menu.addEventListener("click", e => { if (e.target.closest("a")) setMenu(false); });
  document.addEventListener("click", e => { if (!menu.hidden && !e.target.closest("#top")) setMenu(false); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !menu.hidden) { setMenu(false); menuBtn.focus(); } });

  /* ---------- search: live results under the header ---------- */
  const sBtn = $("#searchBtn"), sBox = $("#bxSearch"), sIn = $("#bxSearchIn"), sRes = $("#bxSearchRes");
  if (sBtn && sBox) {
    // product titles are in English: common Arabic words search for their English name
    const AR_WORDS = [["ساع", "watch"], ["برفان", "perfume"], ["بيرفيوم", "perfume"], ["عطر", "perfume"], ["دبدوب", "teddy"], ["دباديب", "teddy"],
      ["شنط", "bag"], ["محفظ", "wallet"], ["كارد", "cardholder"], ["هودي", "hoodie"], ["تيشيرت", "t-shirt"], ["بنطلون", "pants"], ["نضار", "sunglasses"],
      ["سلسل", "necklace"], ["انسيال", "bracelet"], ["إنسيال", "bracelet"], ["خاتم", "ring"], ["حلق", "earrings"], ["فض", "silver"], ["روج", "lipstick"],
      ["ماسكرا", "mascara"], ["كونسيلر", "concealer"], ["كريم", "cream"], ["لوشن", "lotion"], ["شوكولات", "chocolate"], ["كيندر", "kinder"], ["ريدبول", "redbull"],
      ["مج", "mug"], ["كوباي", "mug"], ["ايربودز", "airpods"], ["إيربودز", "airpods"], ["حزام", "belt"], ["ورد", "flower"], ["كاب", "cap"], ["شراب", "socks"],
      ["بورتريه", "portrait"], ["صور", "pictures"], ["كارت", "card"]];
    const toQuery = q => isAr(q) ? (AR_WORDS.find(([a]) => q.includes(a)) || [, q])[1] : q;
    const QUICK = () => L(["ساعات", "برفانات", "دباديب", "هوديز", "شنط", "شوكولاتة"], ["Watch", "Perfume", "Teddy", "Hoodie", "Bag", "Chocolate"]);
    const setSearch = open => {
      sBox.hidden = !open; sBtn.setAttribute("aria-expanded", open); header.classList.toggle("search-open", open);
      if (open) { setMenu(false); header.classList.remove("hide"); sIn.focus(); if (!sIn.value) drawQuick(); }
    };
    const drawQuick = () => {
      sRes.innerHTML = `<p class="bx-sr-h">${L("الأكتر بحثاً", "Popular")}</p><div class="bx-sr-chips">${QUICK().map(t => `<button type="button" data-q>${t}</button>`).join("")}</div>`;
    };
    // on the live store: Shopify's predictive search; where it isn't there (a static preview), the builder's products
    const local = q => {
      const c = json("bxCatalog"); if (!c) return [];
      const seen = new Set(), words = q.toLowerCase().split(/\s+/).filter(Boolean);
      return Object.values(c.prods).flat().filter(p => !seen.has(p.id) && seen.add(p.id) && words.every(w => p.t.toLowerCase().includes(w)))
        .slice(0, 10).map(p => ({ title: p.t, url: `${root}#builder`, price: p.p, image: p.img }));
    };
    // only what the home page sells (the builder's products and the ready boxes): the store still has older products
    // that aren't on the site any more. On other pages the home page is fetched once per visit.
    let home;
    const homeItems = () => home || (home = (async () => {
      try { const c = JSON.parse(sessionStorage.getItem("bxHome")); if (c) return c; } catch (e) {}
      let doc = document;
      if (!$("#bxCatalog")) {
        const r = await fetch(root); if (!r.ok) throw r;
        doc = new DOMParser().parseFromString(await r.text(), "text/html");
      }
      const cat = doc.getElementById("bxCatalog");
      const items = {
        ids: cat ? Object.values(JSON.parse(cat.textContent).prods).flat().map(p => p.id) : [],
        handles: [...doc.querySelectorAll('#ready a[href*="/products/"]')].map(a => a.getAttribute("href").split("/products/")[1].split(/[?#]/)[0]),
      };
      if (!items.ids.length) return null;
      try { sessionStorage.setItem("bxHome", JSON.stringify(items)); } catch (e) {}
      return items;
    })().catch(() => null));
    let ctl, timer;
    const find = async q => {
      ctl && ctl.abort(); ctl = new AbortController();
      const qq = toQuery(q);
      try {
        const [r, onHome] = await Promise.all([fetch(`${root}search/suggest.json?q=${encodeURIComponent(qq)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide`, { signal: ctl.signal }), homeItems()]);
        if (!r.ok) throw r;
        const d = await r.json();
        const keep = p => !onHome || onHome.ids.includes(p.id) || onHome.handles.includes(p.handle);
        return { qq, list: d.resources.results.products.filter(keep).map(p => ({ title: p.title, url: p.url, price: parseFloat(p.price), image: p.featured_image && p.featured_image.url || p.image })) };
      } catch (e) {
        if (e.name === "AbortError") throw e;
        return { qq, list: local(qq) };
      }
    };
    const draw = async () => {
      const q = sIn.value.trim();
      if (!q) return drawQuick();
      sRes.classList.add("busy");
      let res; try { res = await find(q); } catch (e) { return; }
      sRes.classList.remove("busy");
      sRes.innerHTML = res.list.length
        ? `<ul class="bx-sr-list">${res.list.map(p => `<li><a href="${p.url}">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : "<i></i>"}<span>${esc(p.title)}</span><b>${egp(p.price)}</b></a></li>`).join("")}</ul>`
        : `<p class="bx-sr-none">${L(`مفيش حاجة باسم "${esc(q)}". جرّب كلمة تانية، أو`, `Nothing called “${esc(q)}”. Try another word, or`)} <a href="${root}#builder">${L("صمّم البوكس بنفسك", "design your own box")}</a></p>`;
    };
    sBtn.addEventListener("click", e => { e.stopPropagation(); setSearch(sBox.hidden); });
    $("#searchClose").addEventListener("click", () => { setSearch(false); sBtn.focus(); });
    sIn.addEventListener("input", () => { clearTimeout(timer); timer = setTimeout(draw, 220); });
    // Enter just searches here: the full results page would list the old products too
    sIn.form.addEventListener("submit", e => { e.preventDefault(); clearTimeout(timer); draw(); sIn.blur(); });
    sRes.addEventListener("click", e => {
      const b = e.target.closest("[data-q]"); if (b) { sIn.value = b.textContent; draw(); sIn.focus(); return; }
      if (e.target.closest("a")) setSearch(false);
    });
    document.addEventListener("click", e => { if (!sBox.hidden && !e.target.closest("#top")) setSearch(false); });
    document.addEventListener("keydown", e => { if (e.key === "Escape" && !sBox.hidden) { setSearch(false); sBtn.focus(); } });
    menuBtn.addEventListener("click", () => setSearch(false));
  }
}

/* ---------- hero: smoothed scroll progress drives the lid + the things that come out ---------- */
const hero = $("#hero");
if (hero) {
  const hbox = $("#hbox"), hlid = $("#hlid"), pops = $$(".pop");
  const hcopy = $(".hx-copy"), hstage = $(".hx-stage"), hsticky = $(".hx-sticky");
  let target = 0, cur = 0, heroOn = true;
  const readTarget = () => {
    const span = hero.offsetHeight - innerHeight;
    target = span > 0 ? clamp(-hero.getBoundingClientRect().top / span) : 1;
  };
  addEventListener("scroll", readTarget, { passive: true });
  new IntersectionObserver(([e]) => { heroOn = e.isIntersecting; }).observe(hero);
  /* the story, as scroll progress 0 to 1 (slow, scrubbed by the scroll):
     phones: the words lift away and the box glides to the middle, then the lid opens, then the pieces come out one by one;
     laptops: the words stay, the lid opens, then the pieces come out */
  const renderHero = (p, time = 0) => {
    hero.style.setProperty("--p", p.toFixed(4));
    const s = hbox.offsetWidth, phone = mobile.matches;
    if (phone) {
      const c = easeInOut(clamp(p / .22));
      hcopy.style.transform = `translateY(${-48 * c}px)`;
      hcopy.style.opacity = (1 - c).toFixed(3);
      hcopy.style.pointerEvents = c > .5 ? "none" : "";
      // where the box sits in the layout (offsets ignore transforms), and the middle of the screen
      const boxMid = hstage.offsetTop + hstage.parentElement.offsetTop + hbox.offsetTop + hbox.offsetHeight * .58;
      const shift = (hsticky.offsetHeight / 2 - .05 * s - boxMid) * c;
      hstage.style.transform = `translateY(${shift}px)`;
    } else {
      hcopy.style.transform = hstage.style.transform = hcopy.style.opacity = hcopy.style.pointerEvents = "";
    }
    const e = easeInOut(clamp((p - (phone ? .2 : .06)) / .3));
    const flip = !phone && lang === "ar" ? -1 : 1;  // Arabic on laptops: the box sits on the left, so everything mirrors
    const [lx, ly] = phone ? [-30, -80] : [28 * flip, -112];
    hlid.style.transform = `translate(${lx * e}%,${ly * e}%) rotate(${-9 * e}deg) scale(${1 + .03 * e})`;
    const start = phone ? .4 : .26, dur = .2, gap = Math.min(.07, (.86 - start - dur) / Math.max(1, pops.length - 1));  // every piece is out a little before the scene scrolls away
    pops.forEach((el, i) => {
      const t = clamp((p - start - i * gap) / dur), q = easeOut(t);
      const float = Math.sin(time / 1300 + i * 1.7) * 3 * q;  // gentle idle float once out
      const m = phone && el.dataset.mx != null;  // phones: each piece has its own spot around the box
      const [x, y, r] = m ? [+el.dataset.mx, +el.dataset.my, +el.dataset.mr] : [el.dataset.x * flip, +el.dataset.y, el.dataset.r * flip];
      el.style.transform = `translate(-50%,-50%) translate(${x * s * q}px,${y * s * q + float}px) rotate(${r * q}deg) scale(${.55 + .45 * q})`;
      el.style.opacity = clamp(t * 1.8).toFixed(3);
      el.style.filter = q < .98 ? `blur(${(1 - q) * 2.5}px)` : "none";
    });
  };
  window.__hero = p => renderHero(p);  // for checking a moment of the story by hand
  const heroFrame = time => {
    requestAnimationFrame(heroFrame);
    if (!heroOn) return;
    cur += (target - cur) * (reduce || window.__snap ? 1 : .16);  // a little inertia, so it follows the scroll without lagging
    renderHero(cur, time);
  };
  readTarget(); requestAnimationFrame(heroFrame);

  // names typed on the hero lid (Theme editor: Hero > Names on the lid)
  const hname = $("#hname");
  const NAMES = (hname.dataset.names || "").split(",").map(s => s.trim()).filter(Boolean);
  if (NAMES.length) (function typeLoop(i = 0) {
    const word = NAMES[i % NAMES.length];
    hname.classList.toggle("ar", isAr(word));
    let n = 0;
    const type = () => { hname.innerHTML = esc(word.slice(0, ++n)) + '<span class="caret"></span>'; n < word.length ? setTimeout(type, 120) : setTimeout(erase, 2200); };
    const erase = () => { hname.innerHTML = esc(word.slice(0, --n)) + '<span class="caret"></span>'; n > 0 ? setTimeout(erase, 45) : setTimeout(() => typeLoop(i + 1), 300); };
    setTimeout(type, 400);
  })();
}

/* ---------- swipe rows with a ‹ 1/N › pager (categories, ready boxes, TikTok) ---------- */
function makePager(row, bar) {
  if (!row || !bar) return () => {};
  const items = () => [...row.children].filter(x => x.offsetParent !== null);
  const step = () => { const [a, b] = items(); return a && b ? Math.abs(b.offsetLeft - a.offsetLeft) : 1; };
  const update = () => {
    const n = items().length, i = Math.min(n, Math.round(Math.abs(row.scrollLeft) / step()) + 1);
    bar.querySelector(".pg-pos").textContent = `${num(Math.max(1, i))}/${num(n)}`;
    const end = Math.abs(row.scrollLeft) + row.clientWidth >= row.scrollWidth - 4;
    bar.querySelector(".pg-prev").disabled = i <= 1; bar.querySelector(".pg-next").disabled = end;
    bar.hidden = row.scrollWidth <= row.clientWidth + 4;
  };
  row.addEventListener("scroll", update, { passive: true });
  row.addEventListener("scrollend", update);
  addEventListener("resize", update);
  bar.addEventListener("click", e => {
    const b = e.target.closest("button"); if (!b) return;
    const dir = (b.classList.contains("pg-next") ? 1 : -1) * (document.documentElement.dir === "rtl" ? -1 : 1);
    row.scrollBy({ left: dir * step() * Math.max(1, Math.floor(row.clientWidth / step())), behavior: "smooth" });
  });
  return update;
}

/* ---------- ready boxes: the cards come from the collection picked in the editor; these buttons filter them ---------- */
const grid = $("#grid");
if (grid) {
  const gridPager = makePager(grid, $("#gridPager"));
  gridPager();
  $(".filters").addEventListener("click", e => {
    const b = e.target.closest("button"); if (!b) return;
    $$(".filters button").forEach(x => x.classList.toggle("on", x === b));
    const f = b.dataset.f, max = +b.dataset.max;
    $$(".pcard").forEach(c => c.classList.toggle("hide", !(f === "all" || (f === "max" ? +c.dataset.p <= max : c.dataset.f.split(" ").includes(f)))));
    grid.scrollLeft = 0; gridPager();
  });
}
makePager($("#phones"), $("#phonePager"))();

/* ---------- feedback strip: the messages drift by on their own; tap one to read it big ---------- */
const track = $("#fbTrack");
if (track) {
  const zoom = $("#fbZoom"), zimg = zoom.querySelector("img");
  const open = c => { zimg.src = c.dataset.full; zimg.alt = c.querySelector("img").alt; zoom.hidden = false; zoom.querySelector(".fb-x").focus(); };
  const close = () => { zoom.hidden = true; };
  track.addEventListener("click", e => { const c = e.target.closest(".fb-card"); if (c) open(c); });
  zoom.addEventListener("click", close);
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !zoom.hidden) close(); });
}

/* ---------- reveal on scroll ---------- */
$$(".sec-head, .occ-card").forEach(el => el.classList.add("rv"));
const io = new IntersectionObserver(es => es.forEach(x => { if (x.isIntersecting) { x.target.classList.add("in"); io.unobserve(x.target); } }), { threshold: .12 });
$$(".rv").forEach(el => io.observe(el));

/* ================= box builder ================= */
const CATALOG = json("bxCatalog");
if (!CATALOG) return;
const { cats: CATS, prods: PRODS, card: CARD, designs: DESIGNS, occ: OCCS } = CATALOG;
const MAX = CATALOG.max || Infinity;  // 0 = no limit on things in one box
const ROWS = CATS.filter(c => c.decor).map(c => c.h);  // the rows under "decorate the box": shown for everyone
const FOR_LABEL = { her: "ليها", him: "ليه", kid: "لطفل", dad: "للأب", mom: "للأم" };
const FOR_EN = { her: "For her", him: "For him", kid: "For a kid", dad: "For dad", mom: "For mom" };
const FOR_HINT = { her: "for her", him: "for him", kid: "for kids", dad: "for dad", mom: "for mom" };
const catLabel = c => c.l;
const occOf = v => OCCS.find(o => o.v === v);
const occLabel = v => (occOf(v) || { l: v }).l;
const forLabel = k => L(FOR_LABEL[k], FOR_EN[k]);
const dName = d => L(d.name, d.en_name || d.name);
const whoImg = k => { const i = document.querySelector(`.chips[data-group="for"] button[data-v="${k}"] img`); return i ? i.src : ""; };

const state = { name: "", for: "", occ: "", items: [], custom: [], design: null, hand: null, cardMode: "type", cardPhotos: [], cardText: "", cardSong: "" };
const CARD_PRICE = CARD ? CARD.p : 0;
const count = () => state.items.length + state.custom.length;
// the box itself comes with 2 main pieces or more: flowers, decorations and snacks don't count
const MAIN_MIN = 2;
const mains = () => state.items.filter(i => !(CATS.find(c => c.h === i.cat) || {}).decor).length + state.custom.length;
const noBox = () => count() > 0 && mains() < MAIN_MIN;
const NO_BOX = () => L(`البوكس بيطلع مع حاجتين أساسيين على الأقل (الورد والديكور والسناكس مش محسوبين). اختيارك دلوقتي من غير البوكس.`, `The box comes with at least 2 main items (flowers, decorations and snacks don't count). Right now your order doesn't include the box.`);
// Pictures: each photo is one piece, so the line's quantity is the number of photos
const qtyOf = i => i.qty || 1;
const total = () => state.items.reduce((a, i) => a + i.p * qtyOf(i), 0) + (state.design ? CARD_PRICE : 0);
// the card carries typed words or a handwritten note, never both: only the chosen one reaches the order
const cardWords = () => state.cardMode === "type" ? state.cardText.trim() : "";
const cardHand = () => state.cardMode === "hand" ? state.hand : null;
const fits = (p, cat) => {
  const c = CATS.find(x => x.h === cat);
  if (c.decor) return true;
  if (c.herOnly && ["him", "dad"].includes(state.for)) return false;  // e.g. makeup never shows for him or dad
  if (!p.g.length) return state.for !== "kid" || c.kid;  // products in none of the her / him / mom collections suit everyone
  switch (state.for) {
    case "her": return p.g.includes("her");
    case "him": case "dad": return p.g.includes("him") && !c.herOnly;
    case "mom": return p.g.includes("her") || p.g.includes("mom");
    case "kid": return c.kid;
    default: return true;
  }
};
const listFor = h => PRODS[h].filter(p => fits(p, h));
// the photo on a section tile: the cover picked in the editor for that side (her / him), else the side's first product
function coverImgs(h) {
  const c = CATS.find(x => x.h === h), list = listFor(h);
  const side = { her: "her", mom: "her", him: "him", dad: "him" }[state.for];
  let imgs = side === "him" ? [c.coverHim] : side ? [c.cover] : [c.cover, c.coverHim];
  imgs = imgs.filter(Boolean);
  return imgs.length ? imgs : [list[0] && list[0].img].filter(Boolean);
}

const lidName = $("#lidName"), box3d = $("#box3d"), inside = $("#inside"), arrange = $("#arrange");
$("#nameIn").addEventListener("input", e => { state.name = e.target.value; renderLid(); });
function renderLid() {
  const v = state.name.trim();
  lidName.textContent = v || lidName.dataset.ph;
  lidName.classList.toggle("ghost", !v);
  lidName.classList.toggle("ar", isAr(v));
  fitLid();
  renderTray();
}
// Long names shrink to stay on one line inside the lid.
function fitLid() {
  const sign = lidName.parentElement, lid = sign.closest(".lid");
  if (!lid) return;
  sign.style.transition = "none";
  sign.style.fontSize = "";
  const cs = getComputedStyle(lid), room = lid.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
  if (room > 0 && sign.scrollWidth > room) sign.style.fontSize = parseFloat(getComputedStyle(sign).fontSize) * room / sign.scrollWidth + "px";
  sign.offsetWidth;
  sign.style.transition = "";
}
addEventListener("resize", fitLid);

$$(".chips").forEach(group => group.addEventListener("click", e => {
  const b = e.target.closest("button"); if (!b) return;
  group.querySelectorAll("button").forEach(x => x.classList.toggle("on", x === b));
  state[group.dataset.group] = b.dataset.v;
  if (group.dataset.group === "for") renderCats();
  const o = group.dataset.group === "occ" && occOf(b.dataset.v);
  if (o && o.design && !state.design && DESIGNS.some(d => d.id === o.design)) { state.design = o.design; renderCard(); }
  renderMeta();
}));

// category tiles → each opens its own section of real products
function renderCats() {
  $("#forHint").textContent = state.for ? L(`(بيظهرلك حاجات ${FOR_LABEL[state.for]} بس)`, `(showing only things ${FOR_HINT[state.for]})`) : L("(اختار قسم وشوف حاجاته)", "(open a section to see what’s inside)");
  const tile = c => {
    const n = listFor(c.h).length; if (!n) return "";
    const sel = state.items.filter(i => i.cat === c.h).length;
    const imgs = coverImgs(c.h);
    return `<button type="button" class="cat" data-h="${c.h}"><span class="cat-img${imgs.length > 1 ? " two" : ""}">${imgs.map(s => `<img src="${s}" alt="" decoding="async">`).join("")}</span><span class="cat-l">${esc(catLabel(c))} <i aria-hidden="true">${L("←", "→")}</i></span><small>${L(`${num(n)} منتج`, `${num(n)} item${n > 1 ? "s" : ""}`)}</small><span class="badge${sel ? " on" : ""}">${num(sel)}</span></button>`;
  };
  $("#decor").innerHTML = CATS.filter(c => c.decor).map(tile).join("");
  $(".decor-t").hidden = !ROWS.length;
  $("#cats").innerHTML = CATS.filter(c => !c.decor).map(tile).join("") + (CATALOG.custom ? `<button type="button" class="cat custom" data-h="custom"><span class="cat-img">${icon("sparkle")}</span><span class="cat-l">${L("مخصوص", "Custom")}</span><small>${L("اطلب حاجة مش موجودة", "Ask for something else")}</small><span class="badge${state.custom.length ? " on" : ""}">${num(state.custom.length)}</span></button>` : "");
  setTimeout(() => updatePager());
}
const updatePager = makePager($("#cats"), $("#catPager"));
["#cats", "#decor"].forEach(id => $(id).addEventListener("click", e => {
  const b = e.target.closest(".cat"); if (!b) return;
  b.dataset.h === "custom" ? openCustom() : openCategory(b.dataset.h);
}));
$("#slots").innerHTML = (MAX < Infinity ? "<i></i>".repeat(MAX) : "") + `<span id="slotsTxt"></span>`;

/* ---------- the sheet ---------- */
const sheet = $("#sheet");
let onSheetClose = null;
function openSheet({ title, body, foot = "", back = false, mount, close }) {
  $("#sheetTitle").innerHTML = title;
  $("#sheetBody").innerHTML = body;
  $("#sheetBody").onclick = null;
  $("#sheetFoot").innerHTML = foot;
  $("#sheetBack").style.visibility = back ? "visible" : "hidden";
  $("#sheetBody").scrollTop = 0;
  onSheetClose = close || null;
  sheet.classList.add("open"); sheet.setAttribute("aria-hidden", "false");
  document.body.classList.add("lock");
  mount && mount();
}
function closeSheet() {
  sheet.classList.remove("open"); sheet.setAttribute("aria-hidden", "true");
  document.body.classList.remove("lock");
  onSheetClose && onSheetClose(); onSheetClose = null;
}
sheet.addEventListener("click", e => { if (e.target.closest("[data-close]")) closeSheet(); });
addEventListener("keydown", e => { if (e.key === "Escape" && sheet.classList.contains("open")) closeSheet(); });

// the colour / shade / size picked for each product, before and after it goes in the box
const picked = {};
const variantOf = p => (p.vs || []).find(x => x.v === (picked[p.id] || p.v)) || { v: p.v, t: "", p: p.p };
// a size has to be picked by the customer, never assumed
const needsPick = p => p.need && !picked[p.id];
// a flavour / colour with its own photo shows that photo, in the section and in the box (the product's cut-out
// belongs to its main photo, so a different photo goes in framed)
const lookOf = (p, x) => x.img && x.img !== p.img ? { img: x.img, cut: null } : { img: p.img, cut: p.cut };
function openCategory(h) {
  const c = CATS.find(x => x.h === h);
  const draw = () => {
    const list = listFor(h), full = count() >= MAX;
    $("#sheetBody").innerHTML = `<p class="sheet-sub">${L("اختار اللي يعجبك، وهيترص في البوكس على طول", "Pick what you like and it goes straight into the box")}</p>` +
      (list.length ? `<div class="pgrid">${list.map((p, i) => {
        const on = state.items.some(x => x.id === p.id), x = variantOf(p);
        const blank = needsPick(p) ? `<option value="" disabled selected>${L("اختار المقاس", "Select size")}</option>` : "";
        const pick = p.vs ? `<select class="vsel${needsPick(p) ? " need" : ""}" data-id="${p.id}" aria-label="${L(p.need ? "المقاس" : "اختار", p.need ? "Size" : "Choose")}">${blank}${p.vs.map(o => `<option value="${o.v}"${!blank && o.v === x.v ? " selected" : ""}>${esc(o.t)}</option>`).join("")}</select>` : "";
        const tag = p.ph ? `<small class="ph-tag">${icon("image")}${p.ph === "n" ? L(`${egp(p.p)} للصورة`, `${egp(p.p)} a photo`) : L("بصورتك", "With your photo")}</small>` : "";
        return `<article class="prod${on ? " on" : ""}${full && !on ? " full" : ""}" style="--i:${i}">
          <div class="ph"><img src="${lookOf(p, x).img}" alt="${esc(p.t)}" loading="lazy"></div>
          <div class="bd"><h4>${esc(p.t)}</h4>${tag}${pick}<div class="row"><span class="pr">${egp(x.p)}</span>
          <button type="button" class="add" data-id="${p.id}">${on ? L("✓ في البوكس", "✓ In the box") : L("+ ضيف", "+ Add")}</button></div></div></article>`;
      }).join("")}</div>` : `<p class="sheet-empty">${L("مفيش حاجات هنا للاختيار ده", "Nothing here for this choice")}</p>`);
    drawFoot();
  };
  const drawFoot = () => {
    $("#sheetFoot").innerHTML = `<button type="button" class="btn btn-primary" data-close>${L(`تمام · في البوكس ${num(count())} · ${egp(total())}`, `Done · ${num(count())} in the box · ${egp(total())}`)}</button>`;
  };
  openSheet({ title: esc(catLabel(c)), body: "", back: true, mount: draw });
  $("#sheetBody").onchange = e => {
    const s = e.target.closest(".vsel"); if (!s) return;
    const p = PRODS[h].find(x => x.id === +s.dataset.id);
    picked[p.id] = +s.value;
    const x = variantOf(p), it = state.items.find(i => i.id === p.id);
    s.classList.remove("need", "err");
    s.closest(".prod").querySelector(".pr").textContent = egp(x.p);
    s.closest(".prod").querySelector(".ph img").src = lookOf(p, x).img;
    if (it) { Object.assign(it, { v: x.v, p: x.p, vt: x.t }, lookOf(p, x)); drawFoot(); renderBox(null); }
  };
  $("#sheetBody").onclick = e => {
    const b = e.target.closest(".add"); if (!b) return;
    const p = PRODS[h].find(x => x.id === +b.dataset.id);
    const idx = state.items.findIndex(x => x.id === p.id);
    if (idx > -1) state.items.splice(idx, 1);
    else {
      if (count() >= MAX) return;
      if (needsPick(p)) {
        const s = b.closest(".prod").querySelector(".vsel");
        s.classList.remove("err"); void s.offsetWidth; s.classList.add("err", "shake"); s.focus();
        setTimeout(() => s.classList.remove("shake"), 450);
        b.textContent = L("اختار المقاس الأول", "Pick a size first");
        setTimeout(() => { if (!state.items.some(i => i.id === p.id)) b.textContent = L("+ ضيف", "+ Add"); }, 1800);
        return;
      }
      // portraits, Pictures, Kinder with photo: ask for the photo(s) first
      if (p.ph) return openPhotos(p, h);
      const x = variantOf(p);
      state.items.push({ ...p, v: x.v, p: x.p, vt: x.t, cat: h, ...lookOf(p, x) });
    }
    const card = b.closest(".prod");
    card.classList.toggle("on", idx === -1);
    b.textContent = idx === -1 ? L("✓ في البوكس", "✓ In the box") : L("+ ضيف", "+ Add");
    $$("#sheetBody .prod").forEach(el => el.classList.toggle("full", count() >= MAX && !el.classList.contains("on")));
    drawFoot();
    renderBox(idx === -1 ? p.id : null);
  };
}

// the customer's photo(s) for a photo product, plus a song link for the portraits (the team prints it as a QR code)
const readImg = f => new Promise(ok => { const rd = new FileReader(); rd.onload = () => ok(rd.result); rd.readAsDataURL(f); });
const songUrl = v => { const m = String(v).match(/https?:\/\/\S+/i); return m ? m[0] : ""; };
// words printed on the portraits: a short sentence on the 15*20, a date on top and words below on the 10*15
const PRINT_TXT = {
  line: () => [["Sentence", L("جملة صغيرة تتكتب على البورتريه (اختياري)", "A short sentence on the portrait (optional)"), L("مثلاً: أحلى حاجة في حياتي ♡", "e.g. My favourite person ♡")]],
  date: () => [["Date (top)", L("تاريخ يتكتب فوق (اختياري)", "A date on top (optional)"), L("مثلاً: 14.02.2024", "e.g. 14.02.2024")],
               ["Words (bottom)", L("كلام يتكتب تحت (اختياري)", "Words at the bottom (optional)"), L("مثلاً: أول يوم اتقابلنا", "e.g. The day we met")]],
};
const printTxt = p => /15\s*[*x×]\s*20/i.test(p.t) ? "line" : /10\s*[*x×]\s*15/i.test(p.t) ? "date" : "";
const qrImg = (link, size) => `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=10&data=${encodeURIComponent(link)}`;
function openPhotos(p, h) {
  const many = p.ph === "n", x = variantOf(p), photos = [], txt = printTxt(p) ? PRINT_TXT[printTxt(p)]() : [];
  const pics = n => L(n === 1 ? "صورة واحدة" : n === 2 ? "صورتين" : n <= 10 ? `${num(n)} صور` : `${num(n)} صورة`, `${n} photo${n === 1 ? "" : "s"}`);
  const sum = () => egp(x.p * (many ? Math.max(photos.length, 1) : 1));
  openSheet({
    title: esc(p.t), back: true,
    body: `<div class="custom-form photo-form">
      <p class="sheet-sub" style="margin:0">${many ? L(`ارفع الصور اللي عايزها تتطبع وتتلزق في البوكس. كل صورة بـ ${egp(x.p)}.`, `Upload the photos you want printed for the box. Each photo is ${egp(x.p)}.`) : L("ارفع الصورة اللي عايزها تتطبع. صورة واحدة بس.", "Upload the photo you want printed. One photo only.")}</p>
      <label class="up"><input type="file" id="phIn" accept="image/*"${many ? " multiple" : ""} hidden>${icon("image")}<span id="phLbl">${many ? L("اختار الصور", "Choose photos") : L("اختار الصورة", "Choose a photo")}</span></label>
      <div class="cp-thumbs ph-thumbs" id="phThumbs"></div>
      ${many ? `<p class="ph-count" id="phCount" hidden></p>` : ""}
      ${txt.map(([k, l, ph], i) => `<label class="fld-l" for="ptx${i}">${l}</label><input class="fld" id="ptx${i}" data-k="${k}" maxlength="60" placeholder="${ph}">`).join("")}
      ${p.song ? `<label class="fld-l" for="songIn">${L("لينك الأغنية اللي بيحبها (اختياري)", "Link to their favourite song (optional)")}</label>
      <div class="song"><input id="songIn" type="url" inputmode="url" dir="ltr" placeholder="https://open.spotify.com/…"><img id="songQr" alt="" hidden></div>
      <p class="note-box">${L("بنطبعه QR كود على البورتريه، ولما يعمله سكان بيسمع الأغنية. ينفع من سبوتيفاي، يوتيوب، أنغامي أو أبل ميوزك.", "We print it as a QR code on the portrait: scan it and the song plays. Spotify, YouTube, Anghami or Apple Music links all work.")}</p>` : ""}
    </div>`,
    foot: `<button type="button" class="btn btn-primary" id="phAdd">${L("ضيف للبوكس", "Add to box")} · <span id="phSum">${sum()}</span></button>`,
  });
  const draw = () => {
    $("#phThumbs").innerHTML = photos.map((u, i) => `<span><img src="${u}" alt=""><button type="button" data-i="${i}" aria-label="${L("شيل", "Remove")}">×</button></span>`).join("");
    $("#phLbl").textContent = photos.length ? (many ? L("ضيف صور كمان", "Add more photos") : L("غيّر الصورة", "Change the photo")) : (many ? L("اختار الصور", "Choose photos") : L("اختار الصورة", "Choose a photo"));
    $("#phSum").textContent = sum();
    const c = $("#phCount");
    if (c) { c.hidden = !photos.length; c.textContent = `${pics(photos.length)} × ${egp(x.p)} = ${egp(photos.length * x.p)}`; }
  };
  $("#phIn").onchange = async e => {
    const urls = await Promise.all([...e.target.files].map(readImg));
    if (many) photos.push(...urls); else photos.splice(0, 1, ...urls.slice(0, 1));
    e.target.value = ""; draw();
  };
  $("#phThumbs").onclick = e => { const b = e.target.closest("button[data-i]"); if (b) { photos.splice(+b.dataset.i, 1); draw(); } };
  const song = $("#songIn");
  song && (song.oninput = () => { const u = songUrl(song.value), q = $("#songQr"); q.hidden = !u; if (u) q.src = qrImg(u, 160); song.setCustomValidity(""); });
  $("#phAdd").onclick = () => {
    if (!photos.length) { flashIn($("#phAdd"), L(many ? "ارفع صورة واحدة على الأقل" : "ارفع الصورة الأول", many ? "Upload at least one photo" : "Upload the photo first")); return; }
    if (song && song.value.trim() && !songUrl(song.value)) { song.setCustomValidity(L("حط لينك الأغنية كامل، بيبدأ بـ https://", "Paste the full song link, starting with https://")); return song.reportValidity(); }
    if (count() >= MAX) return;
    state.items.push({ ...p, v: x.v, p: x.p, vt: x.t, cat: h, photos: [...photos], qty: many ? photos.length : 1, song: song ? songUrl(song.value) : "", words: txt.map(([k], i) => [k, $(`#ptx${i}`).value.trim()]).filter(w => w[1]) });
    openCategory(h);
    renderBox(p.id);
    flash(L("اتضافت للبوكس ✓", "Added to the box ✓"));
  };
}
// a short message on a sheet button, then back to its text
function flashIn(btn, msg) {
  const was = btn.innerHTML; btn.textContent = msg; btn.classList.add("shake");
  setTimeout(() => { btn.innerHTML = was; btn.classList.remove("shake"); }, 1800);
}

function openCustom() {
  let img = null;
  const drawList = () => state.custom.map((c, i) =>
    `<div class="up" style="cursor:default;border-style:solid">${c.img ? `<img src="${c.img}" alt="">` : icon("sparkle")}<span style="flex:1">${esc(c.t)}</span><button type="button" data-rm="${i}" class="sheet-x">✕</button></div>`).join("");
  openSheet({
    title: L("حاجة مخصوص", "Something custom"), back: true,
    body: `<div class="custom-form">
      <p class="sheet-sub" style="margin:0">${L("حاجة مش في الأقسام؟ اكتبها أو ابعتلنا صورتها، وإحنا نجيبها", "Not in the sections? Write it or send us a photo, and we’ll get it")}</p>
      <input id="cIn" maxlength="50" placeholder="${L("مثلاً: تيشيرت فريقه، أكلته المفضلة، صورة على مج…", "e.g. their team’s jersey, favourite snack, a photo on a mug…")}">
      <label class="up"><input type="file" id="cImg" accept="image/*" hidden><img id="cPrev" alt="" hidden><span>${L("ارفع صورة: للحاجة اللي عايزها، أو صورة تتطبع على مج أو بولارويد", "Upload a photo: of what you want, or one to print on a mug or polaroid")}</span></label>
      <p class="note-box">${L("الحاجة المخصوص سعرها بيتحدد بعد ما فريقنا يشوفها، وهنكلمك نأكد السعر قبل ما نجهّز.", "Custom items are priced once our team sees them, and we’ll call you to confirm the price before we pack.")}</p>
      <div id="cList">${drawList()}</div></div>`,
    foot: `<button type="button" class="btn btn-ghost" data-close>${L("رجوع", "Back")}</button><button type="button" class="btn btn-primary" id="cAdd">${L("ضيف للبوكس", "Add to box")}</button>`,
  });
  $("#cImg").onchange = e => {
    const f = e.target.files[0]; if (!f) return;
    const rd = new FileReader(); rd.onload = () => { img = rd.result; $("#cPrev").src = img; $("#cPrev").hidden = false; }; rd.readAsDataURL(f);
  };
  $("#cAdd").onclick = () => {
    const t = $("#cIn").value.trim(), say = msg => { $("#cIn").setCustomValidity(msg); $("#cIn").reportValidity(); $("#cIn").addEventListener("input", () => $("#cIn").setCustomValidity(""), { once: true }); };
    if (!t) { $("#cIn").focus(); return say(L("اكتب الحاجة اللي عايزها الأول", "Write what you’d like first")); }
    if (count() >= MAX) return say(L(`البوكس اتملى، أقصى حاجة ${num(MAX)} حاجات`, `The box is full, max ${num(MAX)} items`));
    state.custom.push({ t, img }); img = null;
    // close the sheet so the customer sees it drop into the box
    closeSheet();
    renderBox("c" + (state.custom.length - 1));
    flash(L("اتضافت للبوكس ✓", "Added to the box ✓"));
  };
  $("#cList").onclick = e => {
    const b = e.target.closest("[data-rm]"); if (!b) return;
    state.custom.splice(+b.dataset.rm, 1); $("#cList").innerHTML = drawList(); renderBox(null);
  };
}

/* ---------- the box: black shredded paper + neatly arranged picks ---------- */
// each thing gets its own cell: try every rows × columns split and keep the one with the biggest cells,
// so nothing covers anything and everything shrinks a little as the box fills up
const FILL = .84;
const TILT = [-4, 3, -2, 4, 2, -3, 3, -4, 2, -3, 3, -1, 3, -2, 4, -3];
function cellsFor(n, w, h) {
  let best = { cols: 1, rows: 1, s: 0 };
  for (let cols = 1; cols <= Math.max(n, 1); cols++) {
    const rows = Math.ceil(Math.max(n, 1) / cols), s = Math.min(w / cols, h / rows);
    if (s > best.s) best = { cols, rows, s };
  }
  return best;
}
// products with a cut-out photo sit loose in the shreds; the rest go in as small framed photos
const cutOf = p => p.cut || p.img;
function renderBox(added) {
  const n = count();
  box3d.classList.toggle("open", n > 0);
  inside.classList.toggle("has", n > 0);
  const w = arrange.clientWidth || 300, h = arrange.clientHeight || 200;
  const { cols, rows, s } = cellsFor(n, w, h), size = Math.min(s * FILL, h * .8, 150);
  // the last row is centred when it isn't full
  const at = i => {
    const r = Math.floor(i / cols), c = i % cols, m = r === rows - 1 ? n - r * cols : cols;
    const x = (w - m * s) / 2 + (c + .5) * s, y = (h - rows * s) / 2 + (r + .5) * s;
    return `left:${x}px;top:${y}px;width:${size}px;--rot:${TILT[i % TILT.length]}deg`;
  };
  const rm = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg>`;
  arrange.innerHTML = state.items.map((p, i) =>
    `<div class="it cut${p.cut ? "" : " photo"}${p.id === added ? "" : " still"}" style="${at(i)}"><img src="${cutOf(p)}" alt="" onerror="this.onerror=null;this.src='${p.img}';this.parentNode.classList.add('photo')"><button type="button" class="it-x" data-rm="i${i}" aria-label="${L("شيل", "Remove")}">${rm}</button></div>`).join("") +
    state.custom.map((c, j) => {
      const i = state.items.length + j;
      return `<div class="it cut custom${"c" + j === added ? "" : " still"}" style="${at(i)}">${c.img ? `<img src="${c.img}" alt="">` : `<span><em>${icon("sparkle")}</em>${esc(c.t.length > 16 ? c.t.slice(0, 15) + "…" : c.t)}</span>`}<button type="button" class="it-x" data-rm="c${j}" aria-label="${L("شيل", "Remove")}">${rm}</button></div>`;
    }).join("");
  $$("#slots i").forEach((s, i) => s.classList.toggle("on", i < n));
  $("#slotsTxt").textContent = MAX < Infinity ? `${num(n)}/${num(MAX)}` : L(`${num(n)} حاجة في البوكس`, `${num(n)} in the box`);
  const tv = $("#totalVal");
  tv.textContent = `${egp(total())}`;
  tv.classList.remove("bump"); void tv.offsetWidth; tv.classList.add("bump");
  $("#totalNote").textContent = [noBox() && NO_BOX(), state.custom.length && L("+ الحاجات المخصوص بتتسعّر بعد المراجعة", "+ custom items are priced after review")].filter(Boolean).join(" ");
  $("#sendBtn").textContent = n ? L(`أكّد الأوردر · ${egp(total())}`, `Confirm order · ${egp(total())}`) : L("أكّد الأوردر", "Confirm order");
  renderCats(); renderMeta(); renderTray(added);
}
addEventListener("resize", () => renderBox(null));
// take something out of the box: it shrinks away, then the rest re-arrange
arrange.addEventListener("click", e => {
  const b = e.target.closest(".it-x"); if (!b) return;
  const k = b.dataset.rm, it = b.closest(".it");
  if (it.dataset.out) return; it.dataset.out = 1;
  it.animate([{ transform: getComputedStyle(it).transform, opacity: 1 }, { transform: "scale(.4) rotate(-12deg)", opacity: 0 }], { duration: 300, easing: "cubic-bezier(.22,1,.36,1)", fill: "forwards" });
  setTimeout(() => {
    if (k[0] === "i") state.items.splice(+k.slice(1), 1); else state.custom.splice(+k.slice(1), 1);
    renderBox(null);
  }, 300);
});

// the customer's choices under the box: who (their avatar), the occasion (its icon), and what's inside (little photos)
function renderMeta() {
  const f = $("#metaFor"), o = $("#metaOcc"), n = $("#metaCount");
  f.classList.toggle("m-empty", !state.for);
  f.innerHTML = state.for ? `<img class="m-av" src="${whoImg(state.for)}" alt="">${forLabel(state.for)}` : `<span class="m-ic">${icon("teddy")}</span>${L("لمين؟", "For who?")}`;
  o.classList.toggle("m-empty", !state.occ);
  o.innerHTML = `<span class="m-ic">${icon((occOf(state.occ) || {}).icon || "gift")}</span>${state.occ ? esc(occLabel(state.occ)) : L("المناسبة", "Occasion")}`;
  const c = count(), label = lang === "en" ? `${c} item${c === 1 ? "" : "s"}` : c === 0 ? "٠ حاجة" : c === 1 ? "حاجة واحدة" : c === 2 ? "حاجتين" : `${num(c)} حاجات`;
  const pics = [...state.items.map(i => i.img), ...state.custom.map(x => x.img || "")].slice(-4);
  const more = c - pics.length;
  n.classList.toggle("m-empty", !c);
  n.innerHTML = (c ? `<span class="m-stack">${pics.map(s => s ? `<img src="${s}" alt="">` : `<i>${icon("sparkle")}</i>`).join("")}${more > 0 ? `<i>+${num(more)}</i>` : ""}</span>` : `<span class="m-ic">${icon("gift")}</span>`) + label;
}

/* ---------- gift card: design gallery + handwriting ---------- */
const dcard = d => d.img ? `<div class="dcard img${d.fit ? " " + d.fit : ""}"><img src="${d.img}" alt="${esc(dName(d))}" loading="lazy"></div>` : `<div class="dcard" style="--bg:${d.bg};--fg:${d.fg}">
  <span class="deco">${icon(d.deco)}</span>
  <span class="ar">${L(d.ar, d.en)}</span>${lang === "en" ? "" : `<span class="en">${d.en}</span>`}</div>`;
const designOf = id => DESIGNS.find(d => d.id === id);
const cardStep = $("#cardStep");

function renderCard() {
  if (!cardStep) { renderHand(); return renderBox(null); }
  const d = designOf(state.design);
  $("#cpDesignMedia").innerHTML = (d ? dcard(d) : `<span class="cp-empty">${icon("card") + L("من غير كارت", "No card")}</span>`)
    + (d && state.cardPhotos[0] ? `<img class="cp-pin" src="${state.cardPhotos[0]}" alt="">` : "");
  $("#cpDesign .cp-label").textContent = d ? L(`الكارت: ${d.name}`, `Card: ${dName(d)}`) : L("اختار شكل الكارت", "Choose a card");
  $(".card-fields").classList.toggle("off", !d);
  $("#noCard").hidden = !d;
  $("#cardThumbs").innerHTML = state.cardPhotos.map((u, i) => `<span><img src="${u}" alt=""><button type="button" data-i="${i}" aria-label="${L("شيل", "Remove")}">×</button></span>`).join("");
  const g = $("#gcard");
  $("#gFront").innerHTML = d ? dcard(d) + (state.cardPhotos[0] ? `<img class="g-pin" src="${state.cardPhotos[0]}" alt="">` : "") : "";
  const hand = cardHand();
  if (hand) $("#gBack").innerHTML = `<img class="g-hand" src="${hand}" alt="">`; else $("#gBack").textContent = cardWords();
  $("#gBack").classList.toggle("empty", !hand && !cardWords());
  // typed or handwritten: show only the field for the one they picked
  const hm = state.cardMode === "hand";
  $("#cardText").hidden = hm;
  $("#cpHand") && ($("#cpHand").hidden = !hm);
  $$("#msgMode button").forEach(b => { const on = b.dataset.m === state.cardMode; b.classList.toggle("on", on); b.setAttribute("aria-checked", on); });
  $("#cardPhotoUp span").textContent = state.cardPhotos.length ? L("غيّر الصورة", "Change the photo") : L("حط صورة واحدة على الكارت", "Add one photo to the card");
  g.classList.toggle("show", !!d);
  box3d.classList.toggle("carded", !!d);  // makes room under the box for the card
  renderHand();
  renderBox(null);
}
function renderHand() {
  const m = $("#cpHandMedia"); if (!m) return;
  m.innerHTML = state.hand ? `<img src="${state.hand}" alt="${L("رسالتك", "Your message")}">` : `<span class="cp-empty">${icon("pen") + L("دوس واكتب بصباعك", "Tap and write with your finger")}</span>`;
}
$("#gcard").addEventListener("click", () => $("#gcard").classList.toggle("flip"));
$("#gcard").style.pointerEvents = "auto";
if (cardStep) {
  $("#cpDesign").addEventListener("click", () => openCardSheet("design"));
  $("#noCard").addEventListener("click", () => { state.design = null; renderCard(); });
  $("#cardText").addEventListener("input", e => { state.cardText = e.target.value; renderCard(); });
  $("#cardText").addEventListener("focus", () => { if (state.cardText.trim()) $("#gcard").classList.add("flip"); });
  $("#cardText").addEventListener("blur", () => $("#gcard").classList.remove("flip"));
  // a song link printed on the card as a QR code
  $("#cardSong")?.addEventListener("input", e => { const u = songUrl(e.target.value), q = $("#cardSongQr"); state.cardSong = u; q.hidden = !u; if (u) q.src = qrImg(u, 160); e.target.setCustomValidity(""); });
  // one photo on the card: a new one replaces the old
  $("#cardPhotoIn").addEventListener("change", async e => {
    const f = e.target.files[0]; e.target.value = "";
    if (f) { state.cardPhotos = [await readImg(f)]; renderCard(); }
  });
  // the card's fields wait for a design: a tap on them before that opens the designs
  $(".card-fields").addEventListener("click", e => {
    if (state.design) return;
    e.preventDefault(); e.stopPropagation();
    flash(L("اختار شكل الكارت الأول", "Choose a card design first"));
    openCardSheet("design");
  }, true);
  $("#msgMode") && $("#msgMode").addEventListener("click", e => {
    const b = e.target.closest("button[data-m]"); if (!b) return;
    state.cardMode = b.dataset.m; renderCard();
    if (b.dataset.m === "hand" && !state.hand) openCardSheet("hand");
    if (b.dataset.m === "type") $("#cardText").focus();
  });
  $("#cardThumbs").addEventListener("click", e => {
    const b = e.target.closest("button[data-i]"); if (!b) return;
    state.cardPhotos.splice(+b.dataset.i, 1); renderCard();
  });
}
$("#cpHand") && $("#cpHand").addEventListener("click", () => openCardSheet("hand"));

let strokes = [], pen = "#1f1b1a";
function openCardSheet(tab) {
  openSheet({ title: tab === "hand" ? L("رسالة بخط إيدك", "A note in your handwriting") : L("شكل الكارت", "Card design"), body: '<div id="cBody"></div>', mount: () => show(tab) });

  function show(t) {
    if (t === "design") {
      $("#cBody").innerHTML = `<div class="cgrid">${DESIGNS.map((d, i) =>
        `<button type="button" class="cdesign${state.design === d.id ? " on" : ""}" data-d="${d.id}" style="--i:${i}">${dcard(d)}<span>${esc(dName(d))}</span></button>`).join("")}</div>
        <p class="sheet-sub" style="margin-top:14px">${L(`الكارت بـ ${egp(CARD_PRICE)}، والكلام والصورة بتحطهم تحت في الخطوة ٥.`, `The card is ${egp(CARD_PRICE)}. You add the words and your photo below in step 5.`)}</p>`;
      $("#sheetFoot").innerHTML = `<button type="button" class="btn btn-primary" data-close>${L("تمام", "Done")}</button>`;
      $("#cBody").onclick = e => {
        const b = e.target.closest(".cdesign"); if (!b) return;
        state.design = b.dataset.d; $$(".cdesign").forEach(x => x.classList.toggle("on", x === b)); renderCard();
      };
    } else {
      $("#cBody").innerHTML = `<p class="sheet-sub">${L("اكتب بصباعك… بنطبعها على الكارت زي ما هي بخط إيدك", "Write with your finger… we print it on the card exactly as you wrote it")}</p>
        <div class="hand-wrap" id="handWrap"><canvas id="handPad" aria-label="${L("اكتب رسالتك بصباعك", "Write your message with your finger")}"></canvas><span class="hand-ph">${L("اكتب هنا بخط إيدك", "Write here by hand")}</span></div>
        <div class="hand-tools"><div class="pens">${["#1f1b1a", "#8a5a3b", "#b5485a"].map(c => `<button type="button" class="pen${c === pen ? " on" : ""}" data-c="${c}" style="background:${c}" aria-label="${L("لون", "Colour")}"></button>`).join("")}</div>
        <button type="button" id="hUndo">${L("↶ ارجع", "↶ Undo")}</button><button type="button" id="hClear">${L("امسح", "Clear")}</button></div>`;
      $("#sheetFoot").innerHTML = `<button type="button" class="btn btn-ghost" id="hDel">${L("أكتب بالكيبورد", "Type it instead")}</button><button type="button" class="btn btn-primary" id="hSave">${L("حفظ الرسالة", "Save note")}</button>`;
      $("#hDel").onclick = () => { strokes = []; state.hand = null; state.cardMode = "type"; renderCard(); closeSheet(); };
      setupHand();
    }
  }
}

function setupHand() {
  const pad = $("#handPad"), ctx = pad.getContext("2d"), wrap = $("#handWrap");
  const size = () => {
    const r = pad.getBoundingClientRect(), dpr = Math.max(1, devicePixelRatio || 1);
    pad.width = r.width * dpr; pad.height = r.height * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); redraw();
  };
  const redraw = () => {
    ctx.clearRect(0, 0, pad.width, pad.height); ctx.lineCap = "round"; ctx.lineJoin = "round";
    strokes.forEach(s => {
      ctx.strokeStyle = s.c;
      for (let i = 1; i < s.p.length; i++) {
        const a = s.p[i - 1], b = s.p[i], m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        ctx.lineWidth = b.w; ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.quadraticCurveTo(a.x, a.y, m.x, m.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      }
    });
    wrap.classList.toggle("has", strokes.length > 0);
  };
  let cur = null, last = null;
  const pt = e => { const r = pad.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top, t: performance.now() }; };
  pad.onpointerdown = e => { last = pt(e); cur = { c: pen, p: [{ ...last, w: 2.6 }] }; strokes.push(cur); pad.setPointerCapture(e.pointerId); };
  pad.onpointermove = e => {
    if (!cur) return;
    const p = pt(e), v = Math.hypot(p.x - last.x, p.y - last.y) / Math.max(1, p.t - last.t);
    const w = Math.max(1.3, Math.min(3.4, 3.6 - v * 1.5));  // faster stroke = thinner, like ink
    cur.p.push({ ...p, w }); last = p;
    const a = cur.p[cur.p.length - 2]; ctx.strokeStyle = cur.c; ctx.lineWidth = w; ctx.lineCap = "round";
    ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    wrap.classList.add("has");
  };
  pad.onpointerup = pad.onpointercancel = () => { cur = null; };
  $("#hUndo").onclick = () => { strokes.pop(); redraw(); };
  $("#hClear").onclick = () => { strokes = []; redraw(); };
  $$(".pen").forEach(b => b.onclick = () => { pen = b.dataset.c; $$(".pen").forEach(x => x.classList.toggle("on", x === b)); });
  // the note without the empty pad around it, so it reads big in the preview and on print
  const trimmed = () => {
    const pts = strokes.flatMap(s => s.p), pad0 = 14, dpr = pad.width / pad.getBoundingClientRect().width;
    const x0 = Math.max(0, Math.min(...pts.map(p => p.x)) - pad0), y0 = Math.max(0, Math.min(...pts.map(p => p.y)) - pad0);
    const x1 = Math.min(pad.width / dpr, Math.max(...pts.map(p => p.x)) + pad0), y1 = Math.min(pad.height / dpr, Math.max(...pts.map(p => p.y)) + pad0);
    const out = document.createElement("canvas");
    out.width = Math.max(1, (x1 - x0) * dpr); out.height = Math.max(1, (y1 - y0) * dpr);
    out.getContext("2d").drawImage(pad, x0 * dpr, y0 * dpr, out.width, out.height, 0, 0, out.width, out.height);
    return out.toDataURL("image/png");
  };
  $("#hSave").onclick = () => {
    state.hand = strokes.length ? trimmed() : null;
    renderCard();
    closeSheet();
  };
  size();
}

/* ---------- order: summary → the box goes into the Shopify cart → checkout ---------- */
const NOTE = $("#formNote").textContent;
function flash(msg) {
  const n = $("#formNote");
  n.textContent = msg; n.classList.add("err");
  clearTimeout(flash.t);
  flash.t = setTimeout(() => { n.textContent = NOTE; n.classList.remove("err"); }, 3200);
}
const shake = () => { const b = $("#sendBtn"); b.classList.add("shake"); setTimeout(() => b.classList.remove("shake"), 450); };

// who orders and who receives: asked in the review, saved on the order as cart attributes
const det = { name: "", phone: "", email: "", gift: null, rName: "", rPhone: "", note: "" };
const enDigits = v => v.replace(/[٠-٩]/g, d => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[\s-]/g, "");
const okPhone = v => /^01[0125]\d{8}$/.test(enDigits(v));
const okEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
// a gift? is asked first and alone; the answer opens the fields: sender + recipient for a gift, only the buyer otherwise
const person = (who, n, p, auto) => `<p class="bx-od-sub">${who}</p><div class="bx-od-row">
    <label>${L("الاسم", "Name")}<input id="${n}" value="${esc(det[n === "odName" ? "name" : "rName"])}"${auto ? ' autocomplete="name"' : ""}></label>
    <label>${L("رقم الموبايل", "Mobile")}<input id="${p}" value="${esc(det[p === "odPhone" ? "phone" : "rPhone"])}" type="tel" inputmode="tel"${auto ? ' autocomplete="tel"' : ""} dir="ltr" placeholder="01xxxxxxxxx"></label>
  </div>`;
const detailsForm = () => `<fieldset class="bx-od" id="odForm">
  <div class="bx-od-q" id="odQ"><span class="bx-od-qt">${L("الأوردر هدية؟", "IT’S A GIFT?")}</span>
    <div class="bx-seg" role="radiogroup" aria-label="${L("الأوردر هدية؟", "It’s a gift?")}">
      <label><input type="radio" name="odGift" value="1"${det.gift === true ? " checked" : ""}><span>${L("أيوه", "YES")}</span></label>
      <label><input type="radio" name="odGift" value="0"${det.gift === false ? " checked" : ""}><span>${L("لأ", "NO")}</span></label>
    </div>
    <small class="bx-od-err" id="odQErr" hidden>${L("اختار الأول: هدية ولا لأ", "Choose first: is it a gift?")}</small>
  </div>
  <div class="bx-od-body" id="odBody"${det.gift === null ? " hidden" : ""}>
    <div id="odMe">${person(det.gift ? L("بياناتك (المُرسِل)", "Your details (sender)") : L("بياناتك", "Your details"), "odName", "odPhone", true)}</div>
    <div id="odRec"${det.gift ? "" : " hidden"}>${person(L("بيانات اللي هيستلم", "Recipient’s details"), "odRName", "odRPhone")}</div>
    <label>${L("إيميلك", "Your email")}<input id="odEmail" value="${esc(det.email)}" type="email" inputmode="email" autocomplete="email" dir="ltr" placeholder="name@example.com"></label>
    <label class="bx-od-note">${L("عايز تقولنا حاجة؟ (اختياري)", "Anything else? (optional)")}<textarea id="odNote" rows="2" placeholder="${L("مثلاً: التوصيل بعد الساعة ٥، خلّيها مفاجأة…", "e.g. deliver after 5 pm, keep it a surprise…")}">${esc(det.note)}</textarea></label>
  </div>
</fieldset>`;
const readDetails = () => {
  const g = $('#odForm input[name="odGift"]:checked');
  det.gift = g ? g.value === "1" : null;
  det.name = $("#odName").value.trim(); det.phone = $("#odPhone").value.trim(); det.email = $("#odEmail").value.trim();
  det.rName = $("#odRName").value.trim(); det.rPhone = $("#odRPhone").value.trim(); det.note = $("#odNote").value.trim();
};
// the first field that still needs something, with what to tell the customer
const missingDetail = () => {
  if (det.gift === null) return ["#odQ"];
  if (!det.name) return ["#odName", L("اكتب اسمك", "Write your name")];
  if (!okPhone(det.phone)) return ["#odPhone", L("اكتب رقم موبايل مصري من 11 رقم بيبدأ بـ 01", "Write an 11-digit Egyptian mobile number starting with 01")];
  if (!okEmail(det.email)) return ["#odEmail", det.email ? L("الإيميل مش مظبوط، صلّحه", "That email doesn't look right. Please fix it") : L("اكتب إيميلك عشان يوصلك رقم الأوردر وتفاصيله", "Write your email so we can send you the order number and updates")];
  if (det.gift && !det.rName) return ["#odRName", L("اكتب اسم اللي هيستلم", "Write the name of the person receiving it")];
  if (det.gift && !okPhone(det.rPhone)) return ["#odRPhone", L("اكتب رقم موبايل اللي هيستلم: 11 رقم بيبدأ بـ 01", "Write their 11-digit mobile number starting with 01")];
  return null;
};

// paying takes 2 steps after the box: their details here, then address & payment on Shopify's checkout page
// (InstaPay / Vodafone Cash are explained there)
const PAY_STEPS = () => [
  L("بياناتك", "Your details"),
  L("العنوان والدفع", "Address & payment"),
];
const paySteps = (now, short) => `<div class="bx-pay${short ? " short" : ""}"><p class="bx-pay-h">${short ? L("بعد ما تأكد البوكس: خطوتين بس وتخلّص الأوردر", "After the box: just 2 steps to finish") : L("البوكس جاهز 🎁 فاضل خطوتين وتخلّص الأوردر", "Your box is ready 🎁 Just 2 steps to finish")}</p>
<ol class="bx-steps${short ? " short" : ""}" aria-label="${L("الدفع في خطوتين", "Checkout in 2 steps")}">
  ${PAY_STEPS().map((t, i) => `<li${i === now ? ' class="now" aria-current="step"' : ""}><b>${num(i + 1)}</b><span><strong>${t}</strong></span></li>`).join("")}
</ol></div>`;
$("#formNote").insertAdjacentHTML("beforebegin", paySteps(-1, true));

// the page can stay open for a long time: before the review, check the box against the store as it is now,
// so something that sold out meanwhile leaves the box instead of failing at checkout
async function freshStock() {
  try {
    const h = await (await fetch(root, { cache: "no-store" })).text();
    const m = h.match(/<script[^>]*id="bxCatalog"[^>]*>([\s\S]*?)<\/script>/);
    if (!m) return [];
    const fresh = JSON.parse(m[1]), live = new Set();
    Object.keys(PRODS).forEach(k => { PRODS[k] = fresh.prods[k] || []; });
    Object.values(fresh.prods).flat().forEach(p => { live.add(p.v); (p.vs || []).forEach(x => live.add(x.v)); });
    const gone = state.items.filter(p => !live.has(p.v));
    if (gone.length) { state.items = state.items.filter(p => live.has(p.v)); renderBox(null); }
    return gone;
  } catch (e) { return []; }
}

$("#bldForm").addEventListener("submit", async e => {
  e.preventDefault();
  if (!state.name.trim()) { flash(L("اكتب الاسم الأول عشان نكتبه على الغطا", "Write the name first so we can put it on the lid")); $("#nameIn").focus(); return shake(); }
  if (!count()) { flash(L("اختار حاجة واحدة على الأقل تتحط في البوكس", "Pick at least one thing for the box")); return shake(); }
  if (!state.items.length) { flash(L("ضيف منتج واحد على الأقل من الأقسام مع الحاجة المخصوص", "Add at least one product from the sections with your custom item")); return shake(); }
  const send = $("#sendBtn"); send.disabled = true;
  const gone = await freshStock();
  send.disabled = false;
  if (gone.length) {
    flash(L(`${gone.map(p => p.t).join("، ")}: خلص من عندنا واتشال من البوكس. اختار حاجة بداله`, `${gone.map(p => p.t).join(", ")} just sold out and left your box. Pick something else`));
    return shake();
  }
  const cs = $("#cardSong");
  if (state.design && cs && cs.value.trim() && !state.cardSong) { flash(L("حط لينك الأغنية كامل، بيبدأ بـ https://", "Paste the full song link, starting with https://")); cs.focus(); return shake(); }
  const nm = state.name.trim(), d = designOf(state.design);
  openSheet({
    title: L("مراجعة الأوردر", "REVIEW YOUR ORDER"),
    body: `<div class="summary">
      <p class="sum-name">${L("الاسم على البوكس", "Name in the box")} : <b class="nm${isAr(nm) ? " ar" : ""}">${esc(nm)}</b></p>
      <ul class="sum-list">
        ${state.items.map(p => `<li><img src="${p.img}" alt=""><span class="t">${esc(p.t)}${p.vt ? `<small class="sum-v">${esc(p.vt)}</small>` : ""}${p.qty > 1 ? `<small class="sum-v">${L(`${num(p.qty)} صور`, `${p.qty} photos`)}</small>` : ""}
          ${p.photos ? `<span class="sum-ph">${p.photos.map(u => `<img src="${u}" alt="">`).join("")}</span>` : ""}${(p.words || []).map(([, w]) => `<small class="sum-v">“${esc(w)}”</small>`).join("")}${p.song ? `<small class="sum-v">♪ ${esc(p.song.length > 38 ? p.song.slice(0, 37) + "…" : p.song)}</small>` : ""}</span><span class="p">${egp(p.p * qtyOf(p))}</span></li>`).join("")}
        ${state.custom.map(c => `<li>${c.img ? `<img src="${c.img}" alt="">` : `<span class="sum-ic">${icon("sparkle")}</span>`}<span class="t" style="text-align:start">${esc(c.t)}</span><span class="p" style="font-weight:400;font-size:.78rem;color:var(--tan)">${L("بعد المراجعة", "After review")}</span></li>`).join("")}
        ${d ? `<li class="sum-card"><span class="sum-ic">${icon("card")}</span><span class="t" style="text-align:start">${L("كارت", "Card")}: ${esc(dName(d))}
          ${cardHand() ? `<img class="sum-hand" src="${cardHand()}" alt="${L("بخط إيدك", "In your handwriting")}">` : cardWords() ? `<q>${esc(cardWords())}</q>` : `<small class="warn">${L("لسه مكتبتش الكلام اللي على الكارت", "You haven’t written the card’s words yet")}</small>`}
          ${state.cardPhotos.length ? `<span class="sum-ph">${state.cardPhotos.map(u => `<img src="${u}" alt="">`).join("")}</span>` : ""}${state.cardSong ? `<small class="sum-v">♪ ${esc(state.cardSong.length > 38 ? state.cardSong.slice(0, 37) + "…" : state.cardSong)}</small>` : ""}</span><span class="p">${egp(CARD_PRICE)}</span></li>` : ""}
      </ul>
      ${noBox() ? `<p class="note-box no-box">${NO_BOX()}</p>` : ""}
      ${paySteps(0)}
      ${detailsForm()}
      <p class="note-box">${esc(NOTE)}</p>
      <div class="sum-tot"><span>${L("الإجمالي", "Total")}</span><b>${egp(total())}</b></div></div>`,
    foot: `<button type="button" class="btn btn-ghost" data-close>${L("عدّل", "Edit")}</button><button type="button" class="btn btn-primary" id="payBtn">${L("كمّل للخطوة ٢: العنوان والدفع", "Next: address & payment")}</button>`,
  });
  $("#odQ").addEventListener("change", () => {
    readDetails();
    $("#odBody").hidden = false; $("#odQErr").hidden = true; $("#odQ").classList.remove("err");
    $("#odRec").hidden = !det.gift;
    $("#odMe .bx-od-sub").textContent = det.gift ? L("بياناتك (المُرسِل)", "Your details (sender)") : L("بياناتك", "Your details");
  });
  $("#odForm").addEventListener("input", readDetails);
  $("#payBtn").onclick = () => {
    readDetails();
    const miss = missingDetail();
    if (miss && miss[0] === "#odQ") {
      const q = $("#odQ"); q.classList.add("err"); $("#odQErr").hidden = false; q.scrollIntoView({ block: "center", behavior: "smooth" });
      return;
    }
    if (miss) {
      const f = $(miss[0]); f.focus(); f.scrollIntoView({ block: "center", behavior: "smooth" });
      f.setCustomValidity(miss[1]); f.reportValidity(); f.addEventListener("input", () => f.setCustomValidity(""), { once: true });
      return;
    }
    placeOrder($("#payBtn"));
  };
});

// The box reaches the order like this: every product is its own line with the box name on it (photo products also
// carry their photos, and the portraits the song link with its QR code to print); the card line carries the design,
// the typed words or the handwritten note, and the card photo; who / occasion / custom requests go in the cart
// attributes. The team sees all of it on the Shopify order.
const toFile = async (dataUrl, name) => { const b = await (await fetch(dataUrl)).blob(); return new File([b], name, { type: b.type }); };
async function placeOrder(btn) {
  const nm = state.name.trim(), d = designOf(state.design);
  btn.disabled = true; btn.textContent = L("لحظة…", "One moment…");
  try {
    const lines = state.items.map(p => {
      const props = { "Box": nm }, files = [];
      (p.photos || []).forEach((u, i) => files.push([`Photo ${i + 1}`, u, `${p.id}-photo-${i + 1}.jpg`]));
      (p.words || []).forEach(([k, w]) => { props[k] = w; });
      if (p.song) { props["Song link"] = p.song; props["Song QR (print)"] = qrImg(p.song, 1000); }
      return { id: p.v, quantity: qtyOf(p), props, files };
    });
    if (d && CARD) {
      const files = state.cardPhotos.map(u => ["Card photo", u, "card-photo.jpg"]);
      if (cardHand()) files.push(["Handwritten card", cardHand(), "handwritten-card.png"]);
      lines.unshift({ id: CARD.v, quantity: 1, props: { "Box": nm, "Card design": d.en_name || d.name, "Card text": cardHand() ? "Handwritten (see the file)" : cardWords() || "—", ...(state.cardSong && { "Song link": state.cardSong, "Song QR (print)": qrImg(state.cardSong, 1000) }) }, files });
    }
    // the custom items' photos ride on the first line
    state.custom.forEach((c, i) => c.img && lines[0].files.push([`Custom item ${i + 1} photo`, c.img, `custom-${i + 1}.jpg`]));
    const ok = r => { if (!r.ok) throw r; return r; };
    const plain = lines.filter(l => !l.files.length).map(l => ({ id: l.id, quantity: l.quantity, properties: l.props }));
    if (plain.length) await fetch(`${root}cart/add.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: plain }) }).then(ok);
    // lines with files go one by one, as a form, so Shopify stores the files with the order
    for (const l of lines.filter(l => l.files.length)) {
      const fd = new FormData();
      fd.append("id", l.id); fd.append("quantity", l.quantity);
      Object.entries(l.props).forEach(([k, v]) => fd.append(`properties[${k}]`, v));
      for (const [k, u, name] of l.files) fd.append(`properties[${k}]`, await toFile(u, name));
      await fetch(`${root}cart/add.js`, { method: "POST", headers: { Accept: "application/json" }, body: fd }).then(ok);
    }
    const attributes = { "Box name": nm, "Buyer name": det.name, "Buyer phone": enDigits(det.phone), ...(det.email && { "Buyer email": det.email }), "Gift": det.gift ? "Yes" : "No", ...(noBox() && { "Box": "Not included (under 2 main items)" }) };
    if (det.gift) { attributes["Recipient name"] = det.rName; attributes["Recipient phone"] = enDigits(det.rPhone); }
    if (state.for) attributes["Box for"] = FOR_EN[state.for];
    if (state.occ) attributes["Occasion"] = state.occ;
    if (state.custom.length) attributes["Custom requests"] = state.custom.map(c => c.t).join(" | ");
    await fetch(`${root}cart/update.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes, note: det.note }) }).then(ok);
    // contact = the buyer's email when given; delivery = the person receiving the box
    const [first, ...rest] = (det.gift ? det.rName : det.name).split(/\s+/);
    const pre = new URLSearchParams({ ...(det.email && { "checkout[email]": det.email }), "checkout[shipping_address][first_name]": first, "checkout[shipping_address][last_name]": rest.join(" ") || first, "checkout[shipping_address][phone]": enDigits(det.gift ? det.rPhone : det.phone), "checkout[shipping_address][country]": "Egypt" });
    location.href = `${root}checkout?${pre}`;
  } catch (err) {
    btn.disabled = false; btn.textContent = L("حاول تاني", "Try again");
    // 422: Shopify refused a line, almost always because it sold out a moment ago
    if (err && err.status === 422) return flash(L("في حاجة في البوكس لسه خالصة من المخزن. اقفل المراجعة واضغط اطلب تاني عشان نشيلها", "Something in the box just sold out. Close the review and order again so we can take it out"));
    flash(L("حصلت مشكلة وإحنا بنضيف البوكس للسلة، جرّب تاني أو كلّمنا واتساب", "Something went wrong adding the box to the cart. Try again or message us on WhatsApp"));
  }
}

$$(".occ-card").forEach(c => c.addEventListener("click", () => {
  const b = document.querySelector(`.chips[data-group="occ"] button[data-v="${CSS.escape(c.dataset.occ)}"]`);
  b && b.click();
}));

/* ---------- phone tray: mini box while the big one is off-screen ---------- */
const tray = $("#tray"), fab = $("#fab");
let stageVisible = true, panelVisible = false;
function renderTray(added) {
  const nm = state.name.trim();
  $("#trayName").textContent = nm || lidName.dataset.ph;
  $("#trayName").classList.toggle("ar", isAr(nm));
  $("#trayItems").innerHTML = state.items.slice(0, 6).map(p => `<img src="${p.img}" alt="">`).join("") + (state.custom.length ? icon("sparkle") : "");
  $("#trayTotal").textContent = `${egp(total())}`;
  updateTray();
  if (added && tray.classList.contains("show")) tray.animate([{ transform: "scale(1.04)" }, { transform: "none" }], { duration: 450, easing: "cubic-bezier(.22,1,.36,1)" });
}
function updateTray() {
  const show = panelVisible && !stageVisible && (count() > 0 || state.name.trim());
  tray.classList.toggle("show", !!show);
  fab && fab.classList.toggle("hide", !!show);
}
new IntersectionObserver(([x]) => { stageVisible = x.isIntersecting; updateTray(); }, { threshold: .2 }).observe($("#stage"));
new IntersectionObserver(([x]) => { panelVisible = x.isIntersecting; updateTray(); }).observe($("#bldForm"));
tray.addEventListener("click", () => $("#stage").scrollIntoView({ behavior: "smooth", block: "center" }));

renderLid(); renderCats(); renderMeta(); renderCard();
})();
